'use strict';
var debounce = require('lodash/debounce');

/**
 * add sticky class to filter bar.
 * @param {Object} sticky element.
 * @param {Object} stickyWrapper element parent.
 * @param {Object} scrollElement element.
 * @returns {undefined}.
 */
function stickyToggle(sticky, stickyWrapper, scrollElement) {
    var stickyHeight = sticky.outerHeight();
    var stickyTop = stickyWrapper.offset().top;
    var iscollapsedHeader = $('.main-menu .navbar.slide-up').hasClass('hide');
    var StickyParent = stickyWrapper.parent();
    var searchHeaderHeight = $('.sticky-refinement .search-keyword-wrapper').outerHeight() || 0;
    var headerHight = $('header').outerHeight();
    var plpHeight = $('.plp-breadcrumbs').outerHeight();
    var categoryHeight = $('.category-text-main').outerHeight();
    var disclaimerHeight = $('.disclaimer-info').outerHeight();

    if ($('.disclaimer-info').length > 0) {
        $('.refinements-sidebar .refinement-bar-desktop').css('height', 'calc(100vh - ' + (headerHight + plpHeight + categoryHeight + disclaimerHeight + 110) + 'px)');
    } else {
        $('.refinements-sidebar .refinement-bar-desktop').css('height', 'calc(100vh - ' + (headerHight + plpHeight + categoryHeight + 70) + 'px)');
    }

    if (parseInt(scrollElement.scrollTop(), 10) + 146 >= stickyTop) {
        $('.category-text-header').addClass('d-none');
        $('.producttile-row').removeClass('padding-space');
        $('#category-text-main').removeClass('category-text-main');
        stickyWrapper.height(stickyHeight - searchHeaderHeight);
        StickyParent.height(stickyHeight - searchHeaderHeight);
        StickyParent.addClass('sticky-state');
        sticky.addClass('is-sticky');
        headerHight = $('header').outerHeight();
        plpHeight = $('.plp-breadcrumbs').outerHeight();
        categoryHeight = $('.category-text-main').outerHeight();
        disclaimerHeight = $('.disclaimer-info').outerHeight();
        $('.refinements-slide').addClass('sticky-slide');
        if (iscollapsedHeader) {
            sticky.addClass('collapsed-header');
            headerHight = $('header').outerHeight();
            $('.refinements-slide').addClass('scroll-slide');
            $('.refinements-sidebar .refinement-bar-desktop').css('height', 'calc(100vh - ' + (headerHight + 65) + 'px)');
        } else {
            sticky.removeClass('collapsed-header');
            headerHight = $('header').outerHeight();
            $('.refinements-slide').removeClass('scroll-slide');
            $('.refinements-sidebar .refinement-bar-desktop').css('height', 'calc(100vh - ' + (headerHight + 90) + 'px)');
        }
        if ($('.refinements-sidebar').hasClass('scroll-slide')) {
            $('.refinements-sidebar .refinement-bar-desktop').css('height', 'calc(100vh - ' + (headerHight + 80) + 'px)');
            $('.refinements-sidebar .refinement-bar-desktop').removeClass('active');
        } else {
            $('.refinements-sidebar .refinement-bar-desktop').css('height', 'calc(100vh - ' + (headerHight + 100) + 'px)');
            $('.refinements-sidebar .refinement-bar-desktop').addClass('active');
        }
    } else {
        $('.producttile-row').addClass('padding-space');
        $('.category-text-header').removeClass('d-none');
        $('#category-text-main').addClass('category-text-main');
        sticky.removeClass('is-sticky');
        sticky.removeClass('collapsed-header');
        stickyWrapper.height('auto');
        StickyParent.height('auto');
        StickyParent.removeClass('sticky-state');
        $('.refinements-slide').removeClass('sticky-slide');
        headerHight = $('header').outerHeight();
        plpHeight = $('.plp-breadcrumbs').outerHeight();
        categoryHeight = $('.category-text-main').outerHeight();
        disclaimerHeight = $('.disclaimer-info').outerHeight();
        if ($('.disclaimer-info').length > 0) {
            $('.refinements-sidebar .refinement-bar-desktop').css('height', 'calc(100vh - ' + (headerHight + plpHeight + categoryHeight + disclaimerHeight + 110) + 'px)');
        } else {
            $('.refinements-sidebar .refinement-bar-desktop').css('height', 'calc(100vh - ' + (headerHight + plpHeight + categoryHeight + 70) + 'px)');
        }
    }
}
var debouncedStickyToggle = debounce(stickyToggle, 200);

module.exports = function () {
    $('[data-toggle="sticky-onscroll"]').each(function () {
        var sticky = $(this);
        var stickyWrapper = $('<div>').addClass('sticky-wrapper');
        sticky.before(stickyWrapper);
        sticky.addClass('sticky');

        $(window).on('scroll.sticky-onscroll resize.sticky-onscroll', function () {
            debouncedStickyToggle(sticky, stickyWrapper, $(this));
        });

        debouncedStickyToggle(sticky, stickyWrapper, $(window));
    });
};
